import {removeFalsyFields} from '../../../pages/lendtech/receiveCredit/step3-completeDocs/utils/removeFalsyFields';
import request from '../../axios';

export const patchGuarantor = async (payload: IGuarantorPayload) => {
  const cleanedPayload = removeFalsyFields(payload);
  const {data} = await request.patch(
    `/api/v2/payment/loan-guarantors`,
    cleanedPayload,
  );
  return data;
};
